import { Link } from "react-router-dom";
import Wrapper from "../../components/sectionWrapper";
import { media } from "../../libs/media";
import Messages from "./translations/CheckOutSee.json";
import { Icon } from "@iconify/react";
// import Messages from "./translations/Secure.json";
import { useLangContext } from "../../components/translateContext";
import { useState } from "react";
// import buttonText from "../../translations/button.json";
export default function CheckOutSee() {
  const { Lang } = useLangContext();
  const Infos = { msg: Messages[Lang] };

  const [name, setName] = useState(" ");
  const [email, setEmail] = useState("");
  const [nameError, setNameError] = useState("");
  const [emailError, setEmailError] = useState("");

  const SendRequest = (e) => {
    e.preventDefault();

    // Reset previous error messages
    setNameError("");
    setEmailError("");

    // Validation logic
    let isValid = true;

    if (name.trim() === "") {
      setNameError("Please enter your name.");
      isValid = false;
    }

    if (email.trim() === "") {
      setEmailError("Please enter your email.");
      isValid = false;
    }

    if (!isValid) {
      // If validation fails, don't proceed with the submission
      return;
    }

    // initiale body for request  ==> m = mandatory = obligatoire
    var data = {
      type: "all", // in checkout value is mobile/card/all ==> m
      transref: new Date().getTime(), // transref ===> m et unique
      qosKey: "QCBJ137", // is provided by qos platform  ==> m
      returnUrl: "https://www.qosic.com/checkout", // is callback redirection with parameter transref ans status ==> m
      amountDetails: {
        totalAmount: 100, // amount wil be pay by customer //  ==> m
        currency: "XOF",
      },
      saleDetails: {
        firstName: ".", // m
        lastName: name, // m
        middleName: "KJ",
        nameSuffix: "jac",
        title: "Mr", // m
        address1: "Cotonou", // m
        address2: "Cococodji",
        address4: "string",
        locality: "Litoral", // m
        administrativeArea: "",
        postalCode: "229", // m
        country: "Benin", // m
        district: "Bj", // m
        buildingNumber: "string",
        email: email, // m
        emailDomain: "string",
        phoneNumber: "66895585", // m
        phoneType: "cel", // m
      },
    };

    fetch("https://b-card.qosic.net/public/v1/initTransaction", {
      // fetch("http://localhost:9011/public/v1/initTransaction", {
      //fetch("https://b-checkout-api.qosic.net/public/v1/initTransaction", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((res) => {
        console.log(res);

        window.location.href = res.url;
      });
  };

  return (
    <Wrapper childrenClassName="mb-20 relative" className="bg-white md:pb-6">
      <div className="relative  flex mb-8 align-center justify-center   text-center  ">
        <div>
          <p className="text-qosblackText font-bold md:leading-40 md:text-Nw2  md:pt-24 ">
            {" "}
            {Infos.msg.HelloText}
          </p>
          <p className="text-qosblackgray font-normal md:text-Mobilw22 mt-2  my-2 md:mt-0 w-full md:px-20  md:py-4 ">
            {Infos.msg.description}
          </p>
        </div>
      </div>
      <div className="w-full flex  justify-center align-center">
        <div className="w-full md:w-9/12 bg-qosdark  p-4 md:px-10 md:py-14 rounded-lg">
          <form className="text-qoswhite" onClick={SendRequest}>
            <div className="w-full">
              <p className="text-qoswhite font-normal md:text-Mobilw22  font-semibold">
                {Infos.msg.Full}
              </p>
              <input
                style={styles}
                required
                placeholder={Infos.msg.Enter}
                onChange={(e) => {
                  setName(e.target.value);
                }}
                type="text"
                className="w-full h-20 p-4 rounded-lg border border-qosInput bg-qosInput"
              />
              <p className="text-qosred">{nameError}</p>
            </div>
            <div className="w-full mt-10">
              <p className="text-qoswhite font-normal md:text-Mobilw22 font-semibold">
                {Infos.msg.Email}
              </p>
              <input
                style={styles}
                type="email"
                required
                placeholder={Infos.msg.EnterEmail}
                onChange={(e) => {
                  setEmail(e.target.value);
                }}
                value={email}
                className="w-full h-20 p-4 rounded-lg border border-qosInput bg-qosInput"
              />
              <p className="text-qosred">{emailError}</p>
            </div>

            <div className="w-full mt-14">
              <button
                type="submit"
                className="w-full h-20 bg-qosorange rounded-lg md:text-Mobilw22 font-semibold text-qoswhite p-4"
              >
                {Infos.msg.Pay} 100 FCFA
              </button>
            </div>
          </form>
        </div>
      </div>
    </Wrapper>
  );
}

const styles = {
  borderColor: "#0c0e45",
};
